import { turboproApiLista } from '@/api/turbopro';
import type { CampoApi, ListarCamposResponse } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function listarCamposApi(relatorioId: string): Promise<ListarCamposResponse> {
  const params = new URLSearchParams({
    relatorio_id: relatorioId,
  });

  const resposta = await turboproApiLista<CampoApi>(
    `Relatorios/ListarCampos?${params.toString()}`,
    { headers: getRelatoriosHeaders() }
  );
  return resposta.data ?? [];
}
